import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { endpoints } from '../constants/Endpoints';
import {
  M_ChatInternalConversation,
  M_ChatInternalMessage,
  M_ChatInternalPreferences,
  M_SendMessageRequest,
  M_SendMessageResponse,
} from '../models/M_ChatInternal';

@Injectable({ providedIn: 'root' })
export class ChatInternalService {
  private http = inject(HttpClient);

  getConversations(): Observable<{ data: M_ChatInternalConversation[] }> {
    return this.http.get<{ data: M_ChatInternalConversation[] }>(
      endpoints.chatInternalConversations.url,
    );
  }

  sendMessage(request: M_SendMessageRequest): Observable<{ data: M_SendMessageResponse }> {
    return this.http.post<{ data: M_SendMessageResponse }>(
      endpoints.chatInternalSendMessage.url,
      request,
    );
  }

  createConversation(): Observable<{ data: M_ChatInternalConversation }> {
    return this.http.post<{ data: M_ChatInternalConversation }>(
      endpoints.chatInternalCreateConversation.url,
      {},
    );
  }

  getMessages(conversationId: number): Observable<{ data: M_ChatInternalMessage[] }> {
    const url = endpoints.chatInternalMessages.url.replace('{id}', String(conversationId));
    return this.http.get<{ data: M_ChatInternalMessage[] }>(url);
  }

  deleteConversation(conversationId: number): Observable<void> {
    const url = endpoints.chatInternalDeleteConversation.url.replace(
      '{id}',
      String(conversationId),
    );
    return this.http.delete<void>(url);
  }

  getPreferences(): Observable<{ data: M_ChatInternalPreferences }> {
    return this.http.get<{ data: M_ChatInternalPreferences }>(
      endpoints.chatInternalGetPreferences.url,
    );
  }

  updatePreferences(
    prefs: M_ChatInternalPreferences,
  ): Observable<{ data: M_ChatInternalPreferences }> {
    return this.http.put<{ data: M_ChatInternalPreferences }>(
      endpoints.chatInternalUpdatePreferences.url,
      prefs,
    );
  }

  updateConversation(id: number, title: string): Observable<{ data: M_ChatInternalConversation }> {
    const url = endpoints.chatInternalUpdateConversation.url.replace('{id}', String(id));
    return this.http.put<{ data: M_ChatInternalConversation }>(url, { title });
  }
}
